module.exports = __webpack_public_path__ + "img/44.7.Chla.6f0e372f.png";